import React from 'react';
//import { useSelector } from 'react-redux';
import PatientProfileForm from '../../components/PatientProfileForm/PatientProfileForm';
import "./style.scss";

function PatientProfile() {
  //const user = useSelector((state) => state.auth?.user?.data);

  /* if (user?.role_id !== 1) {
    return "Your are not authorized to view this page";
  } */
    
  return (
    <div>
        <PatientProfileForm  />
    </div>
  );
}

export default PatientProfile;
